import BaseService from "./BaseService";

export default class DeParaService extends BaseService {

  constructor(self) {
    super(self);
  }


  insertDePara(model) {
    return this.ExecutaFetch("/api/DePara/InsertDePara", "POST", model);
  }

  updateDePara(model) {
    return this.ExecutaFetch("/api/DePara/UpdateDePara", "POST", model);
  }

  deleteDePara(id) {
    return this.ExecutaFetch("/api/DePara/DeleteDePara/" + id, "POST");
  }

  getAllDePara() {
    return this.ExecutaFetch("/api/DePara/GetAllDePara", "GET");
  }

  getDeParaById(id) {
    return this.ExecutaFetch("/api/DePara/GetDeParaById/" + id, "GET");
  }

}